import template   from './my-devices-tab.html'
import controller from './my-devices-tab.controller'

let component = {
  restrict: 'E',
  template,
  controller
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/manage-my-rlink/my-updates/my-devices-tab/my-devices-tab.component.js